<script setup lang="ts">
const items = [
  {
    title: 'Reminder Otomatis',
    description: 'Ingatkan pelanggan untuk order ulang tanpa kirim manual.',
    icon: 'material-symbols:notifications-outline'
  },
  {
    title: 'Broadcast WhatsApp',
    description: 'Promosikan produk baru ke semua pelanggan sekaligus.',
    icon: 'ic:baseline-whatsapp'
  },
  {
    title: 'Ucapan & Pesan Personal',
    description:
      'Kirim pesan “Terima kasih” atau “Selamat Hari Raya” otomatis.',
    icon: 'material-symbols:campaign-outline'
  }
]
</script>

<template>
  <UiSectionWrapper
    title="Semua Bisa Jalan Otomatis Tanpa Tambah Tim, Tanpa Ribet"
    hero-image="/images/roms-banner-7.webp"
    :items="items"
    class="py-12"
    :with-action="false"
  />
</template>
